import { FaqAccordionItems } from '@app/widgets';

export const PARTNERS_FAQS: FaqAccordionItems[] = [
  {
    question: 'What types of partners does Capawesome work with?',
    answer: [
      'We partner with development agencies, system integrators, consultants, and technology vendors who serve businesses',
      'requiring mobile app solutions. Our ideal partners have experience with Capacitor, Ionic, or mobile app development',
      'and are committed to delivering high-quality solutions to their clients.',
    ].join(' '),
  },
  {
    question: 'What benefits do Capawesome partners receive?',
    answer: [
      'Partners enjoy priority support, free access to Capawesome Cloud and Capawesome Insiders for development,',
      'participation in roadmap planning, custom plugin development opportunities, access to our private affiliate and referral program,',
      'and promotional opportunities including partner spotlights and case studies.',
    ].join(' '),
  },
  {
    question: 'How does the affiliate and referral program work?',
    answer: [
      'Partners can earn commissions through our private affiliate program by promoting Capawesome products.',
      'Additionally, partners receive referral bonuses for bringing new customers to the Capawesome ecosystem.',
      'Program details and commission structures are shared during the onboarding process.',
    ].join(' '),
  },
  {
    question: 'What does free development access include?',
    answer: [
      'Partners receive complimentary access to Capawesome Cloud and Capawesome Insiders for their development projects and testing environments.',
      'This allows partners to build expertise, create demos, and develop solutions without upfront costs.',
      'Usage limits and terms are defined based on your partnership tier.',
    ].join(' '),
  },
  {
    question: 'How can partners influence the product roadmap?',
    answer: [
      'Partners can participate in product roadmap discussions and provide input on future features based on client needs and market insights.',
      'We hold regular partner advisory sessions where partners can share feedback and help prioritize development efforts.',
      'This ensures our products continue to meet real-world requirements.',
    ].join(' '),
  },
  {
    question: 'What custom plugin development opportunities are available?',
    answer: [
      'Partners have access to custom plugin development services and collaboration opportunities for unique client requirements.',
      'This includes both developing specialized solutions and participating in joint development projects.',
      'We also provide technical guidance and support for partners building their own plugins.',
    ].join(' '),
  },
];

export const PARTNERS_OPENFORGE_FAQS: FaqAccordionItems[] = [
  {
    question: 'What makes OpenForge different from other development agencies?',
    answer: [
      'OpenForge is a trusted Capawesome partner with deep expertise in all Capawesome plugins and Capawesome Cloud.',
      'Unlike general agencies, they specialize in Capacitor development and have intimate knowledge of the ecosystem,',
      'ensuring optimal integration and performance for your mobile apps.',
    ].join(' '),
  },
  {
    question: 'How does OpenForge handle Capawesome Cloud integration?',
    answer: [
      'OpenForge has specialized knowledge in implementing and optimizing Capawesome Cloud for over-the-air updates at enterprise scale.',
      'They ensure seamless integration, proper configuration, and optimal performance for live updates in production environments.',
    ].join(' '),
  },
  {
    question:
      'What is the typical timeline for a Capacitor project with OpenForge?',
    answer: [
      'OpenForge delivers mobile applications 30% faster than industry standards through optimized development processes.',
      'Typical timelines range from 8-16 weeks for most projects, depending on complexity and requirements.',
      'They provide detailed project timelines during the consultation phase.',
    ].join(' '),
  },
  {
    question: 'Does OpenForge provide ongoing support and maintenance?',
    answer: [
      'Yes, OpenForge offers comprehensive post-launch support including bug fixes, updates, performance monitoring, and feature enhancements.',
      'They also provide technical advisory services to help you scale and evolve your mobile app strategy over time.',
    ].join(' '),
  },
  {
    question:
      'Can OpenForge help migrate existing apps to use Capawesome plugins?',
    answer: [
      'Absolutely. OpenForge has extensive experience migrating existing Capacitor and Ionic apps to use Capawesome plugins and Cloud services.',
      'They handle the migration process carefully, ensuring minimal disruption to your existing app while adding powerful new capabilities.',
    ].join(' '),
  },
];
